<template>
  <div id="scatterChart"></div>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "ScatterChart",
  props: {
    labels: {
      type: Array,
    },
    revenue: {
      type: Array,
    },
    profitability: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    loadChart() {
      var options = {
        series: [
          {
            name: "RoE",
            // data: [28, 29, 33, 36, 32, 32, 33],
            data: this.revenue,
          },
          {
            name: "RoCE",
            // data: [12, 11, 14, 18, 17, 13, 13],
            data: this.profitability,
          },
        ],
        chart: {
          height: this.$vuetify.breakpoint.smAndUp ? 350 : 250,
          type: "line",
          // dropShadow: {
          //   enabled: true,
          //   color: "#000",
          //   top: 18,
          //   left: 7,
          //   blur: 10,
          //   opacity: 0.2,
          // },
          toolbar: {
            show: false,
          },
        },
        // dataLabels: {
        //   enabled: true,
        //   offsetX: -6,
        //   style: {
        //     fontSize: "12px",
        //     // colors: ["#fff"],
        //   },
        // },
        colors: ["#77B6EA", "#545454"],
        stroke: {
          curve: "smooth",
        },
        // title: {
        //   text: "Average High & Low Temperature",
        //   align: "left",
        // },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
          categories: this.labels,
        },

        // legend: {
        //   position: "top",
        //   horizontalAlign: "right",
        //   floating: true,
        //   offsetY: -25,
        //   offsetX: -5,
        // },
      };

      var chart = new ApexCharts(document.querySelector("#scatterChart"), options);
      chart.render();
    },
  },
  mounted() {
    this.loadChart();
  },
};
</script>
